export default __webpack_public_path__ + "static/media/kz.529937f0.svg";